module.exports = __webpack_public_path__ + "static/img/eq15.8f985b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/eq15.png
// module id = qjQs
// module chunks = 0